import BudgetPercentageInput from '../BudgetPercentageInput';

interface IBudgetPercentageFieldsMobileProps {
  volkstotalPercentage?: number;
  dealershipPercentage?: number;
  warrantyPercentage?: number;
  showPercentageFields?: boolean;
  onVolkstotalPercentageChange?: (value: number) => void;
  onDealershipPercentageChange?: (value: number) => void;
  onWarrantyPercentageChange?: (value: number) => void;
}

const BudgetPercentageFieldsMobile = (props: IBudgetPercentageFieldsMobileProps) => {
  if (props.showPercentageFields === false) {
    return null;
  }

  const volkstotal = props.volkstotalPercentage || 0;
  const dealership = props.dealershipPercentage || 0;
  const warranty = props.warrantyPercentage || 0;
  const clientPercentage = Math.max(0, 100 - (volkstotal + dealership + warranty));

  return (
    <div className="flex flex-col gap-3 items-start flex-shrink-0 w-full">
      <div className="flex w-full flex-col flex-shrink-0 mb-3">
        <div className="font-bold mb-2 text-size-12 text-gray-500 whitespace-nowrap">% Cliente</div>
        <BudgetPercentageInput
          value={clientPercentage}
          onChange={() => {}}
          placeholder="00%"
          disabled={true}
        />
      </div>
      <div className="flex w-full flex-col flex-shrink-0 mb-3">
        <div className="font-bold mb-2 text-size-12 text-gray-500 whitespace-nowrap">% Volkstotal</div>
        <BudgetPercentageInput
          value={props.volkstotalPercentage || 0}
          onChange={(value) => props.onVolkstotalPercentageChange?.(value)}
          placeholder="00%"
          max={Math.max(0, 100 - (dealership + warranty))}
        />
      </div>
      <div className="flex w-full flex-col flex-shrink-0 mb-3">
        <div className="font-bold mb-2 text-size-12 text-gray-500 whitespace-nowrap">% Concessionária</div>
        <BudgetPercentageInput
          value={props.dealershipPercentage || 0}
          onChange={(value) => props.onDealershipPercentageChange?.(value)}
          placeholder="00%"
          max={Math.max(0, 100 - (volkstotal + warranty))}
        />
      </div>
      <div className="flex w-full flex-col flex-shrink-0 mb-3">
        <div className="font-bold mb-2 text-size-12 text-gray-500 whitespace-nowrap">Garantia</div>
        <BudgetPercentageInput
          value={props.warrantyPercentage || 0}
          onChange={(value) => props.onWarrantyPercentageChange?.(value)}
          placeholder="00%"
          max={Math.max(0, 100 - (volkstotal + dealership))}
        />
      </div>
    </div>
  );
};

export default BudgetPercentageFieldsMobile;
